import styled from 'styled-components';
import { default as C } from '@assets/themes/colors';

export const Root = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 38px;
  height: 38px;
  border-radius: 19px;
  background-color: ${C.BLUE};
`

export const Text = styled.div`
  font-family: Roboto;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.WHITE};
`
